const API_URL = '';

export const api = {
  getNews: async () => {
    try {
      const response = await fetch(`${API_URL}/api/vk-news`);
      return await response.json();
    } catch (error) {
      return { success: false, news: [], error: error.message };
    }
  },
  
  getPromotions: async () => {
    try {
      const response = await fetch(`${API_URL}/api/vk-promotions`);
      return await response.json();
    } catch (error) {
      return { success: false, promotions: [] };
    }
  },
  
  checkVK: async () => {
    try {
      const response = await fetch(`${API_URL}/api/vk-check`);
      return await response.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  },
  
  getAvailableSlots: async (court, date) => {
    try {
      const response = await fetch(`${API_URL}/api/available-slots?court=${court}&date=${date}`);
      return await response.json();
    } catch (error) {
      return { success: false, availableSlots: [] };
    }
  },
  
  bookCourt: async (bookingData) => {
    try {
      const response = await fetch(`${API_URL}/api/booking`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData),
      });
      return await response.json();
    } catch (error) {
      return { success: false, message: error.message };
    }
  },
  
  sendCertificate: async (certificateData) => {
    try {
      const response = await fetch(`${API_URL}/api/certificate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(certificateData),
      });
      return await response.json();
    } catch (error) {
      return { success: false, message: error.message };
    }
  },
  
  // НОВЫЕ МЕТОДЫ ДЛЯ ОТМЕНЫ ЗАПИСИ
  getBookingInfo: async (bookingId) => {
    try {
      const response = await fetch(`${API_URL}/api/booking/${bookingId}`);
      return await response.json();
    } catch (error) {
      return { success: false, message: error.message };
    }
  },
  
  cancelBooking: async (bookingId) => {
    try {
      const response = await fetch(`${API_URL}/api/booking/${bookingId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok) throw { response: { data } };
      return data;
    } catch (error) {
      if (error.response?.data) throw error;
      return { success: false, message: error.message };
    }
  },
  
  test: async () => {
    try {
      const response = await fetch(`${API_URL}/api/test`);
      return await response.json();
    } catch (error) {
      return { error: error.message };
    }
  }
};

export default api;